import { all, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import { PayloadAction } from "@reduxjs/toolkit";

import { NetworkError, SocketError } from "./error.store";
import errorActions from "./error.actions";

function displayNetworkError({ payload: error }: PayloadAction<NetworkError>): void {
  if (error.status !== 401) {
    toast.error(
      `Error ${error.status}: ${error.statusText} - ${String(
        typeof error.details === "object" ? (error.details as { message: string }).message : String(error.details)
      )}`
    );
  }
}

function displaySocketError({ payload: error }: PayloadAction<SocketError>): void {
  const message: string = error.message ? String(error.message) : "Unknown error";
  toast.error(`Error: ${message}`);
}

export function* errorSaga(): Generator {
  yield all([
    takeLatest(errorActions.setNetworkErrorAction, displayNetworkError),
    takeLatest(errorActions.setSocketErrorAction, displaySocketError)
  ]);
}
